(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery', './utils/TokenHelpers'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node, CommonJS-like
        module.exports = factory(
            require('jquery'),
            require('./utils/TokenHelpers')
        );
    } else {
        // Browser globals (root is window)
        root.Wiretap = factory(root.jQuery, root.TokenHelpers);
    }
})(this, ($, TokenHelpers) => {
    /**
     * Wiretap - Base class for Analytics tracking.
     * @param {object}   trackingConfig A JSON object of events to track.
     * @param {function} tokenHelpers   (optional) Function helpers to replace tracking event tokens.
     * @param {object}   pageConfig     (optional) Additional static page data.
     * @constructor
     */
    function Wiretap(trackingConfig, tokenHelpers, pageConfig) {
        this.pageContextData =
            (window.adobeAnalytics && window.adobeAnalytics.contextData) || {};
        this.trackingConfig =
            (typeof trackingConfig === 'string'
                ? JSON.parse(trackingConfig)
                : trackingConfig) || {};
        this.tokenHelpers = Object.assign({}, TokenHelpers);
        this.pageConfig = pageConfig || {};

        if (tokenHelpers) {
            if (typeof tokenHelpers === 'function') {
                this.setTrackingProps = tokenHelpers; // TODO: < 2.0.0 implementation.
            } else if (typeof tokenHelpers === 'object') {
                $.extend(this.tokenHelpers, tokenHelpers); // ~2.0.0 implementation.
            }
        }
    }

    Wiretap.prototype = {
        constructor: Wiretap,

        /**
         * Remove non-tracking properties from the tracking object,
         * and Fire the tracking call
         * @param {object} trackObj Params for the track-event call.
         */
        track(trackObj) {
            delete trackObj.wire;

            //TODO - missing the meta partial that loads the Adobe Async call.
            if (typeof window.trackAsync === 'function') {
                window.trackAsync(trackObj);
            }
        },

        /**
         * Function to be called when an event should trigger a tracking request.
         * @param {object} data The tracking object.
         */
        trackEventHandler(data) {
            this.track(data);
        },

        /**
         * Set the variables inside the tracking event object.
         * Should be overridden by the custom section implementations.
         * @param  {object} trackObj Config properties.
         */
        setTrackingProps(trackObj) {
            return trackObj;
        }
    };

    return Wiretap;
});
